import CryptoAES from 'crypto-js/aes';
import CryptoEnc from 'crypto-js/enc-utf8';
import React from 'react';
import config from '../../config';
import Can from './Can';

// Cache decrypted app state at module scope across calls, and invalidate it when AppStateStorage changes or is cleared.
let _cachedRaw = null;
let _cachedAppState = null;

// Live permissions kept in sync by App.render() so renderWithPermissions works
// even before the debounced sessionStorage write has fired (e.g. incognito / fresh load).
let _livePermissions = null;

export function setLivePermissions(permissions) {
    _livePermissions = permissions;
}

export const renderWithPermissions = (yes, permission, no, rule) => 
{
    const { encKey } = config.sessionStorage;
    const appStateInSession = sessionStorage.getItem('AppStateStorage');
    let appState = null;

    if (appStateInSession && appStateInSession === _cachedRaw) {
        appState = _cachedAppState;
    } else if (appStateInSession) {
        try {
            const decryptedAppState = CryptoAES.decrypt(appStateInSession.toString(), encKey).toString(CryptoEnc);
            appState = JSON.parse(decryptedAppState);
            _cachedRaw = appStateInSession;
            _cachedAppState = appState;
        } catch (error) {
            appState = null;
            _cachedRaw = null;
            _cachedAppState = null;
        }
    } else {
        _cachedRaw = null;
        _cachedAppState = null;
    }

    // Use live permissions as fallback when sessionStorage hasn't been written yet.
    const permissions = (appState && Array.isArray(appState.permissions))
        ? appState.permissions
        : _livePermissions;

    if (!Array.isArray(permissions)) {
        return <></>;
    }

    let path = window.location.pathname.substring(1);
    path = path.endsWith('/') ? path.substring(0, path.length - 1) : path;
    const ruleProp = rule ?? `${path}/${permission ?? 'view'}`;
    if (no)
    {
        return <Can rule={ruleProp} yes={yes} no={no} permissions={permissions} />;
    }
    else {
        return <Can rule={ruleProp} yes={yes} permissions={permissions} />;
    }
}

export const userHasPermission = (permissions, permission, rule) =>
{
    if (rule) {
        return permissions.includes(rule);
    }
    if (permission)
    {
        return permissions.includes(`${window.location.pathname.substring(1)}/${permission}`);
    }
    else {
        return permissions.includes(window.location.pathname.substring(1));
    }
}